// extracted by mini-css-extract-plugin
export default {"post":"post_post__ujBuY","capa":"post_capa__MTBW4","titulo":"post_titulo__uHHEh","botaoLer":"post_botaoLer__0ZCQl"};